var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#3474B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 11.625V20.375C19.8122 20.607 19.72 20.8294 19.5559 20.9934C19.3919 21.1575 19.1695 21.2497 18.9375 21.25H16.9688C16.7368 21.2497 16.5144 21.1575 16.3503 20.9934C16.1863 20.8294 16.094 20.607 16.0938 20.375V11.625C16.094 11.393 16.1863 11.1706 16.3503 11.0066C16.5144 10.8425 16.7368 10.7503 16.9688 10.75H18.9375C19.1695 10.7503 19.3919 10.8425 19.5559 11.0066C19.72 11.1706 19.8122 11.393 19.8125 11.625V11.625ZM13.0312 10.75H11.0625C10.8305 10.7503 10.6081 10.8425 10.4441 11.0066C10.28 11.1706 10.1878 11.393 10.1875 11.625V20.375C10.1878 20.607 10.28 20.8294 10.4441 20.9934C10.6081 21.1575 10.8305 21.2497 11.0625 21.25H13.0312C13.2632 21.2497 13.4856 21.1575 13.6497 20.9934C13.8137 20.8294 13.906 20.607 13.9062 20.375V11.625C13.906 11.393 13.8137 11.1706 13.6497 11.0066C13.4856 10.8425 13.2632 10.7503 13.0312 10.75V10.75Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f4e18680.svg";
export { ForwardRef as ReactComponent };